import axios from 'axios';
import { getAuthHeaders } from '../Services/AuthService';

const apiClient = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
});

// Request interceptor to attach auth token
apiClient.interceptors.request.use(
    async (config) => {
        const headers = await getAuthHeaders();
        config.headers.Authorization = headers.Authorization;
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Response interceptor for error handling
apiClient.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            // Redirect to sign-in on unauthorized
            window.location.href = '/';
        }
        return Promise.reject(error);
    }
);

export default apiClient;
